"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.69,4.49a3.81,3.81,0,0,0-3.8,3.8c0,2,3.44,7.24,3.59,7.47a.26.26,0,0,0,.43,0c.15-.22,3.59-5.45,3.59-7.47A3.81,3.81,0,0,0,10.69,4.49Zm-.07,5.7a2.07,2.07,0,1,1,2.07-2.07A2.07,2.07,0,0,1,10.62,10.18Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.4,14.36c-.52.86-.94,1.5-1.06,1.69A.78.78,0,0,1,10,16c-.12-.18-.54-.83-1.06-1.69-1,.05-4.5.25-4.5,1.25,0,1.19,5,1.29,6.2,1.29s6.2-.1,6.2-1.29C16.9,14.62,13.38,14.41,12.4,14.36Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24.85,24.15l-6.27-6.27a10.73,10.73,0,1,0-.71.71l6.26,6.26a.5.5,0,0,0,.71-.71ZM1,10.69a9.69,9.69,0,1,1,9.69,9.69A9.7,9.7,0,0,1,1,10.69Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;